import { Injectable } from '@angular/core';
import querystring from 'query-string';
import { environment } from '../../../environments/environment';


@Injectable()
export class UtilsService {

  constructor() {}

  static checkIfJSON(data: any) {
    try {
      data = JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.log('checkIfJSON:', error, data);
      data = JSON.parse(JSON.stringify({}));
    }

    return data;
  }

  static checkIfArray(data: any): Array<any> {
    try {
      data = JSON.parse(JSON.stringify(data));
    } catch (error) {
      data = [];
    }

    return Array.isArray(data) ? data : [];
  }

  static parseLists(data: any) {
    data.shapelist = data.shapelist.join(', ');

    return data;
  }
}
